var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3346 26.0125C7.89131 26.0125 2.66797 20.7891 2.66797 14.3459C2.66797 7.90254 7.89131 2.6792 14.3346 2.6792C20.7779 2.6792 26.0013 7.90254 26.0013 14.3459C26.0013 20.7891 20.7779 26.0125 14.3346 26.0125ZM14.3346 23.6792C19.4893 23.6792 23.668 19.5006 23.668 14.3459C23.668 9.19121 19.4893 5.01253 14.3346 5.01253C9.17998 5.01253 5.0013 9.19121 5.0013 14.3459C5.0013 19.5006 9.17998 23.6792 14.3346 23.6792ZM15.5013 14.3459H20.168V16.6792H13.168V8.51253H15.5013V14.3459Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ba4221e4c082c26e9de1f4466195b4a5.svg";
export { ForwardRef as ReactComponent };